import React from 'react';
import { Form, Button } from 'react-bootstrap';
import Layout from '../../layout/layout';
import livered from '../../../assets/images/livegames/livered.svg';
import liveredsm from '../../../assets/images/livegames/liveredsm.svg';
import searchicon from '../../../assets/images/header/search.svg';
import fire from '../../../assets/images/livegames/fire.svg';
import game1 from '../../../assets/images/livegames/game1.png';
import game2 from '../../../assets/images/livegames/game2.png';
import game3 from '../../../assets/images/livegames/game3.png';
import arrow from '../../../assets/images/coins/arrow-left.svg';
import info from '../../../assets/images/header/info.svg';
import './livegames.css';
import SearchBody from '../../search/searchbody';

const LiveGames = () => {
  return (
    <Layout>
      <div className='livegames-page'>
      <div className='games-header'>
        <div className="games-head">
          <div className='games-heading'>
              <h2>
                <img src={livered} alt=''></img>Live Games
              </h2>

              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                 eiusmod tempor incididunt ut labore et dolore magna
                aliqua.
              </p>
            </div>
            <div className='games-search-box'>
              <Form>
                <div className=''>
                  <Form.Group>
                    <div className='ref-input input-img'>
                      <img src={searchicon} alt='' />
                      <Form.Control
                        type='text'
                        placeholder='Search for a game...'
                      />
                      <div className='ref-input-btn'>
                        <Button>SEARCH</Button>
                      </div>
                    </div>
                  </Form.Group>
                </div>
              </Form>
            </div>
        </div> 
      </div>
        <div className='container'>
          <div className='games-body'>
            <div className='top-games'>
              <div className='top-games-heading'>
                <h2>
                  <img src={fire} alt=''></img>Top Live Games
                </h2>
              </div>
              <div className='top-games-arrow'>
                <div className='left-arrow'>
                  <img src={arrow} alt='right-arrow' />
                </div>
                <div className='right-arrow'>
                  <img src={arrow} alt='right-arrow' />
                </div>
              </div>
            </div>
            <div className='games-result'>
              <div className='game-result-box'>
                <div className='game-result-sub-box'>
                  <img src={game1} alt='game' />
                </div>
                <div className='info-box'>
                  <div className='info-heading'>
                    <h6>Sweet Bonanza</h6>
                    <p>Pragmatic Play</p>
                  </div>
                  <div className='info-icon'>
                    <img src={info} alt='info' />
                  </div>
                </div>
              </div>
              <div className='game-result-box'>
                <div className='game-result-sub-box'>
                  <img src={game2} alt='game' />
                </div>
                <div className='info-box'>
                  <div className='info-heading'>
                    <h6>Sweet Bonanza XMAS</h6>
                    <p>Pragmatic Play</p>
                  </div>
                  <div className='info-icon'>
                    <img src={info} alt='info' />
                  </div>
                </div>
              </div>
              <div className='game-result-box'>
                <div className='game-result-sub-box'>
                  <img src={game3} alt='game' />
                </div>
                <div className='info-box'>
                  <div className='info-heading'>
                    <h6>Gates of Olympus</h6>
                    <p>Pragmatic Play</p>
                  </div>
                  <div className='info-icon'>
                    <img src={info} alt='info' />
                  </div>
                </div>
              </div>
            </div>
            <div className='all-live-games'>
              <SearchBody title='All Live Games' titleImg={liveredsm} />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default LiveGames;
